import { atom } from "recoil";

export const assetCreateFormErrorsAtom = atom<boolean>({
  key: "assetCreateFormErrors",
  default: false,
});
